/**
 * 前台 CMS「關於我們」一鍵範本（POST /client/commerce/pages 用 body）。
 * Slug 固定為 about，與前台預設頁腳 /about 路徑對齊。
 */
export function buildDefaultAboutUsPageBody() {
  return {
    title: '關於我們',
    slug: 'about',
    pageType: 'custom',
    status: 'active',
    sortOrder: 0,
    seoTitle: '關於我們',
    seoDescription: '認識我們的品牌故事、經營理念與服務承諾。',
    seoKeywords: '關於我們,品牌故事,商店簡介',
    blocks: [
      {
        type: 'hero',
        props: {
          title: '關於我們',
          subtitle: '用心為您挑選每一份美好',
          imageUrl: '',
          ctaLabel: '瀏覽商品',
          ctaHref: '/products',
        },
      },
      {
        type: 'richtext',
        props: {
          html:
            '<p>歡迎來到我們的線上商店。我們相信優質的商品與誠懇的服務，能為日常帶來一點安心與驚喜。</p>' +
            '<p>此頁為後台「前台頁面管理」建立的範本，您可依品牌調整文字、上傳 Hero 背景圖或增刪區塊。若有任何問題，歡迎透過「聯絡我們」與我們聯繫。</p>' +
            '<p><strong>經營理念</strong>：品質把關、透明資訊、貼心售後。</p>',
        },
      },
    ],
  }
}
